import useConfirmationSubmit from '../hooks/useConfirmationSubmit';
import '../CSS/pages.css';

function OverTheRoad() {
  const { handleSubmit, isSubmitting, submitError } = useConfirmationSubmit(
    'overTheRoad',
    'Over-the-Road support'
  );

  return (
    <main className="page service-page">
      <section className="page-heading">
        <p className="eyebrow">Over-the-Road</p>
        <h1>OTR dispatch support for carriers ready to run farther.</h1>
        <p>
          Evaluate stronger freight options, coordinate pickup and delivery
          details, limited dead end,  and stay supported across longer-haul trips from booking
          through delivery.
        </p>
      </section>

      <section className="contact-layout">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Name
            <input type="text" name="name" placeholder="Your name" required />
          </label>
          <label>
            Email
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </label>
          <label>
            Phone number
            <input type="tel" name="phone" placeholder="(555) 000-0000" required />
          </label>
          <label>
            Equipment type
            <select name="equipmentType" defaultValue="" required>
              <option value="" disabled>
                Select equipment type
              </option>
              <option value="dry-van">Dry van</option>
              <option value="reefer">Reefer</option>
              <option value="flatbed">Flatbed</option>
              <option value="step-deck">Step deck</option>
              <option value="box-truck">Box truck</option>
              <option value="power-only">Power only</option>
              <option value="hotshot">Hotshot</option>
            </select>
          </label>
          <label>
            Message
            <textarea
              name="message"
              rows="5"
              placeholder="Tell us about your OTR goals, schedule, equipment, or dispatch needs"
              required
            />
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Request OTR dispatch support'}
          </button>
          {submitError && <p className="form-error">{submitError}</p>}
        </form>

        <aside className="contact-panel">
          <h2>What this service covers</h2>
          <p>
            Longer-haul dispatch support for carriers who want freight options,
            steady communication, and practical route planning while running
            over the road.
          </p>
          <ul>
            <li>OTR load opportunity review</li>
            <li>Pickup and delivery coordination</li>
            <li>Route and timing support</li>
            <li>Broker communication assistance</li>
          </ul>
        </aside>
      </section>
    </main>
  );
}

export default OverTheRoad;
